import { useCallback, useEffect, useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  CardHeader,
  Grid,
} from "@material-ui/core";

// @material-ui/icons components
import { Apple as AppleIcon, Android as AndroidIcon } from "@material-ui/icons";

import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import componentStyles from "assets/theme/views/admin/react-bs-table";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useCustomStyles = makeStyles((theme) => ({
  downloadBtn: {
    textDecoration: "none",
    "&:hover": {
      color: theme.palette.white.main,
    },
  },
}));

const fetchIntegration = async (chave) => {
  return await Api.get(
    "list-configuration-integration",
    "configurationIntegration",
    "?idMarca=1&sistema=PORTALB2B&chave=" + chave,
    true
  );
};

function BaixarAplicativo() {
  const classes = { ...useStyles(), ...useCustomStyles() };

  const isMobile = IsMobile();

  const itemXS = isMobile ? 12 : "auto";
  const snackbar = useSnackbar();
  const [apkDownloadLink, setApkDownloadLink] = useState(null);
  const [ipaDownloadLink, setIpaDownloadLink] = useState(null);

  const fetchApkLink = useCallback(async () => {
    await fetchIntegration("LinkApkAndroid")
      .then((res) => {
        setApkDownloadLink(res.Result[0].Valor);
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  }, [snackbar]);

  const fetchIpaLink = useCallback(async () => {
    await fetchIntegration("LinkIpaApple")
      .then((res) => {
        setIpaDownloadLink(res.Result[0].Valor);
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  }, [snackbar]);

  useEffect(() => {
    fetchApkLink();
    fetchIpaLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderClientes section="Baixar Aplicativo" subsection="Mobile" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Aplicativo para vendedores Karsten"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={itemXS}>
                    <Button
                      fullWidth
                      variant="contained"
                      classes={{
                        root:
                          classes.downloadBtn + " " + classes.buttonRootWhite,
                      }}
                      component="a"
                      href={apkDownloadLink}
                      disabled={MaskAndValid.isNullOrEmpty(apkDownloadLink)}
                      style={{ display: "flex" }}
                      startIcon={
                        <AndroidIcon style={{ width: 18, height: 18 }} />
                      }
                      onClick={() => {
                      }}
                    >
                      Baixar Aplicativo para Android
                    </Button>
                  </Grid>
                  <Grid item xs={itemXS}>
                    <Button
                      fullWidth
                      variant="contained"
                      classes={{
                        root:
                          classes.downloadBtn + " " + classes.buttonRootWhite,
                      }}
                      component="a"
                      disabled={MaskAndValid.isNullOrEmpty(ipaDownloadLink)}
                      href={ipaDownloadLink}
                      style={{ display: "flex" }}
                      startIcon={
                        <AppleIcon style={{ width: 18, height: 18 }} />
                      }
                    >
                      Baixar Aplicativo para iOS
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default BaixarAplicativo;
